import { format } from 'date-fns'
import numberFormat from '@/utils/numberFormat'

function formatValue(v) {
  return [null, '', 'NaN'].includes(v) ? '-' : numberFormat(v, 'max8')
}

export default function LiquidationHistory({ history }) {
  const {
    liquidation_id,
    timestamp,
    transfer_amount_to_insurance_fund,
    positions_by_perp
  } = history

  const HistoryList = positions_by_perp.map(
    ({ symbol, transfer_price, position_qty, abs_liquidation_fee }, index) => {
      const [marketType, baseCurrency, quoteCurrency] = symbol.split('_')
      const marketSymbol =
        marketType === 'PERP'
          ? `${baseCurrency}-PERP`
          : `${baseCurrency}/${quoteCurrency}`
      return (
        <tr key={`${liquidation_id}_${index}`} className="table-list-row">
          <td className="table-list-cell">{marketSymbol}</td>
          <td className="table-list-cell">{formatValue(transfer_price)}</td>
          <td className="table-list-cell">{formatValue(position_qty)}</td>
          <td className="table-list-cell">
            {formatValue(transfer_amount_to_insurance_fund)}
          </td>
          <td className="table-list-cell">
            {formatValue(abs_liquidation_fee)}
          </td>
          <td className="table-list-cell align-right">
            {format(new Date(timestamp), 'yyyy-MM-dd HH:mm:ss')}
          </td>
        </tr>
      )
    }
  )
  return <>{HistoryList}</>
}
